import { ColorGrid } from "@/components/site/ColorGrid";
import { ContactCTA } from "@/components/site/ContactCTA";
import { motion } from "framer-motion";

export default function CataloguePage() {
    return (
        <main className="bg-bone text-ink" data-testid="page-catalogue">
            <section className="pt-32 md:pt-40 pb-8 border-b border-ink/10">
                <div className="mx-auto max-w-[1440px] px-6 md:px-10">
                    <div className="font-mono text-[10px] uppercase tracking-widest text-ink/50">
                        Home · 03 / Colour Library
                    </div>
                    <motion.h1
                        initial={{ opacity: 0, y: 24 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 1 }}
                        className="mt-4 font-display text-6xl md:text-8xl lg:text-9xl leading-[0.9] tracking-[-0.02em]"
                    >
                        The <span className="italic text-brand-red">library</span>.
                    </motion.h1>
                    <p className="mt-6 max-w-xl text-ink/70 text-lg">
                        Ninety-plus shades across four collections — Interior Premium, Exterior
                        Premium, Textured Exteriors and Easy Care. Tap any tile to send that colour
                        code straight to us on WhatsApp.
                    </p>
                </div>
            </section>

            <ColorGrid />
            <ContactCTA />
        </main>
    );
}
